import { useCallback, useState, useContext } from 'react';
import { readFile } from '../../../../api/utils';
import { AppContext } from '../../../../providers/authProvider';
import api from '../../../../api/req';
import { checkTaskPromise } from '../../../../api/checktask';

// eslint-disable-next-line import/prefer-default-export
export const useExchangeFiles = () => {
  const { currentUser, auth } = useContext(AppContext);
  const [files, setFiles] = useState([]);
  const [data, setData] = useState({ org: currentUser.org });
  const [err, setErr] = useState(null);
  const [process, setProcess] = useState(false);
  const [percent, setPercent] = useState(0);

  const onAddFiles = useCallback(
    (flz) => {
      Promise.allSettled([...flz].map((f) => readFile(f)))
        .then((fs) => setFiles(fs.filter((f) => f.status === 'fulfilled').map((f) => ({
          filename: f.value.file.name,
          content: f.value.result,
          loading: false,
          success: false,
          error: null,
          type: f.value.file.type,
        }))))
        .catch((e) => setErr(e.message));
    },
    [],
  );

  const onDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onAddFiles(e.dataTransfer.files);
    },
    [onAddFiles],
  );
  const onFileInputChange = useCallback(
    (e) => {
      onAddFiles(e.target.files);
    },
    [onAddFiles],
  );
  const onDragOver = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer.dropEffect = 'link';
    },
    [],
  );

  const onApplyFiles = useCallback(
    () => {
      const applyFile = async (file, i) => {
        setFiles((fs) => fs.map((f, k) => (k === i ? ({ ...f, loading: true, error: null }) : f)));
        const r = await api.post('/api/initial/loadgrk/', auth, {
          filename: file.filename,
          org_id: data.org ? data.org.id : null,
          content: file.content,
        });
        if (!r.ok) {
          setFiles((fs) => fs.map((f, k) => (k === i ? ({ ...f, error: `${r.status} ${r.statusText}` }) : f)));
        }
        const task = await r.json();
        const result = await checkTaskPromise(task.task_id, auth);
        if (result.result.errors) {
          setFiles((fs) => fs.map((f, k) => (k === i ? ({ ...f, error: result.result.errors.join(', ') }) : f)));
        } else {
          setFiles((fs) => fs.map((f, k) => (k === i ? ({ ...f, success: true }) : f)));
        }
        setFiles((fs) => fs.map((f, k) => (k === i ? ({ ...f, loading: false }) : f)));
      };
      setPercent(0);
      setProcess(true);
      const r = files.reduce((p, file, i) => p.then(() => {
        setPercent(Math.round((i * 100) / files.length));
        return applyFile(file, i);
      }), Promise.resolve());
      r
        .catch((e) => setErr(e.message))
        .finally(() => setProcess(false));
    },
    [auth, data.org, files],
  );
  const onCleanFiles = useCallback(
    () => setFiles([]),
    [],
  );

  const onDeleteFile = useCallback(
    (filename) => setFiles((ff) => ff.filter((f) => f.filename !== filename)),
    [],
  );

  return {
    err,
    onDrop,
    onDragOver,
    onFileInputChange,
    data,
    setData,
    currentUser,
    files,
    onApplyFiles,
    onCleanFiles,
    process,
    percent,
    onDeleteFile,
  };
};
